<template>
  <div class="row">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div class="col-12" style="padding-left: 5px; padding-right: 5px">
      <div
        class="card card-style"
        :style="backgroundStyle"
        style="
          background-color: white;
          margin-left: 0px;
          margin-right: 0px;
          color: black;
        "
        v-if="personSelected == false"
      >
        <div class="card-body text-center" id="card-geral">
          <h3 class="card-title"><strong>ATENÇÃO !!!</strong></h3>
          <h5>SOLICITAR ATENDIMENTO AO SAMU</h5>
        </div>
        <div class="form-group text-right" style="padding: 10px">
          <ul class="list-unstyled">
            <li class="mb-1" style="font-size: 16px; color: black">
              Se a vítima estiver com:
            </li>
            <li class="text-right">
              - Dificuldade ou impossibilitado de respirar
            </li>
            <li class="text-right">- Dores, aperto ou pressão no peito</li>
            <li class="text-right">
              - Formigamento ou dormência no braço esquerdo
            </li>
            <li class="text-right">- Inconsciente ou com fala embaralhada</li>
            <li class="text-right">- Rosto paralisado</li>
            <li class="text-right">- Ou se a vítima estiver sangrando muito</li>
          </ul>
        </div>
        <div class="text-center mb-2">
          <button class="btn btn-danger" @click="discar192()" id="discar">
            Ligar para o SAMU (192)
          </button>
        </div>
        <div class="text-center mb-1" style="padding: 5px">
          Para outras situações, ou quando estiver com dificuldade de ligar para
          o SAMU, você poderá solicitar o atendimento e conversar diretamente
          com a central. Para isso, clicando em umas das opções abaixo e
          registre sua solicitação.
        </div>
      </div>
      <div
        class="card card-style"
        style="background-color: white; margin-left: 0px; margin-right: 0px"
      >
        <div class="card-body text-center" id="card-geral">
          <div class="form-group mb-3">
            <h5 class="card-title">SOLICITAR ATENDIMENTO</h5>
          </div>
          <div
            class="d-flex justify-content-center align-items center mb-5"
            v-if="personSelected == false"
          >
            <section>
              <div class="row">
                <div class="col-12 mb-2">
                  <h5>PARA QUEM VOCÊ ESTÁ SOLICITANDO ESTE ATENDIMENTO?</h5>
                </div>
                <div class="col-12 mt-3">
                  <button
                    class="btnn"
                    :style="
                      'width: 80% !important; margin: 0; height: 100%; background:' +
                      cor.eu +
                      ' !important;'
                    "
                    @click="atendimento(1)"
                    id="eu"
                  >
                    Preciso de um atendimento <br />
                    para mim
                  </button>
                </div>
                <div class="col-12 mt-3">
                  <button
                    class="btnn"
                    :style="
                      'width: 80% !important; margin: 0; height: 100%; background:' +
                      cor.outro +
                      ' !important;'
                    "
                    @click="atendimento(0)"
                    id="outro"
                  >
                    Preciso de um atendimento <br />
                    para outra pessoa
                  </button>
                </div>
              </div>
            </section>
          </div>

          <div class="form-group" id="form" style="display: none">
            <h5>Solicitante</h5>
            <input
              type="text"
              class="form-control mb-2"
              v-model="user.usuario_nome"
              :disabled="true"
            />

            <!-- <v-select
              v-if="typePerson == 2"
              v-model="favorito_selecionado"
              :options="favoritos"
              :label="'nome_paciente'"
              class="vselect mb-2"
              v-on:input="selectFavorito()"
            ></v-select> -->

            <div
              class="row d-flex justify-content-center align-items center mb-3"
            >
              <!-- <div class="col-4">
                <button
                
                  class="btnn"
                  :style="
                    'padding-left: 4px; padding-right: 4px; width: 95% !important; margin: 0; height: 100%; background:' +
                    cor.gps +
                    ' !important;'
                  "
                  @click="localizacao(0)"
                >
                  GPS
                </button>
              </div> -->
              <!-- <div class="col-4">
                <button class="btnn" :style="'padding-left: 4px; padding-right: 4px; width: 95% !important; margin: 0; height: 100%; background:' + cor.mapa + ' !important;'" @click="localizacao(1)">
                  Mapa
                </button>
              </div> -->
              <!-- <div class="col-4" v-if="favoritos.length != 0">
                <button
                  class="btnn"
                  :style="
                    'padding-left: 4px; padding-right: 4px; width: 95% !important; margin: 0; height: 100%; background:' +
                    cor.fav +
                    ' !important;'
                  "
                  @click="localizacao(2)"
                >
                  Favoritos
                </button>
              </div> -->

              <h5 class="mt-3">Endereço da Ocorrência</h5>
              <div class="col-6">
                <button class="btn-gps btn-sm mb-3" @click="myAddress()">
                  Usar endereço cadastrado
                </button>
              </div>
              <div class="col-6">
                <button class="btn-gps btn-sm mb-3" @click="getGeo()">
                  Usar localização atual
                </button>
              </div>
              <div class="col-12 mt-1 mb-2">
                <input
                  type="tel"
                  placeholder="CEP"
                  class="form-control"
                  v-on:keyup="buscar"
                  v-mask="'99999-999'"
                  v-model="ocorrencia.cep"
                />
              </div>
              <div class="col-12 mt-1">
                <input
                  placeholder="Logradouro"
                  type="text"
                  class="form-control"
                  v-model="ocorrencia.logradouro"
                  v-on:input="getLatLngOpenStreetMap()"
                />
              </div>
              <div class="col-12 mt-1">
                <input
                  placeholder="Número"
                  type="text"
                  class="form-control"
                  v-model="ocorrencia.numero"
                  v-on:input="getLatLngOpenStreetMap()"
                />
              </div>

              <div class="col-12 mt-1">
                <input
                  placeholder="Complemento"
                  type="text"
                  class="form-control"
                  v-model="ocorrencia.complemento"
                />
              </div>
              <div class="col-12 mt-2">
                <input
                  placeholder="Bairro"
                  type="text"
                  class="form-control"
                  v-model="ocorrencia.bairro"
                  v-on:input="getLatLngOpenStreetMap()"
                />
              </div>
              <div class="col-12 mt-2">
                <v-select
                  :options="estados"
                  :reduce="(estados) => estados.uf_id"
                  :label="'uf_nome'"
                  v-model="ocorrencia.estado"
                  class="vselect"
                  v-on:input="getCidades(), getLatLngOpenStreetMap()"
                ></v-select>
              </div>
              <div class="col-12 mt-2">
                <v-select
                  :options="cidades"
                  :reduce="(cidades) => cidades.municipio_id"
                  :label="'municipio_nome'"
                  v-model="ocorrencia.cidade"
                  class="vselect"
                  :disabled="ocorrencia.estado ? false : true"
                  v-on:input="getLatLngOpenStreetMap()"
                ></v-select>
              </div>
              <div class="col-12 mt-3" id="mapa">
                <GmapMap
                  v-if="mapLoaded"
                  :center="{
                    lat: ocorrencia.latitude,
                    lng: ocorrencia.longitude,
                  }"
                  :options="{
                    zoomControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                    fullscreenControl: false,
                  }"
                  :zoom="16"
                  map-type-id="roadmap"
                  style="
                    width: auto;
                    height: 250px;
                    border-radius: 50px !important;
                  "
                  class="mb-3"
                >
                  <GmapMarker :position="position"></GmapMarker>
                </GmapMap>
              </div>
              <div class="col-12 mb-3 mt-3" v-if="typePerson == 2">
                <toggle-button
                  :labels="{ checked: 'Sim', unchecked: 'Não' }"
                  :width="55"
                  v-model="nao_identificado"
                />
                Vítima não identificada
              </div>
              <div class="col-12 mb-2">
                <h5>
                  {{ nao_identificado ? "Aparência aproximada" : "Vítima" }}
                </h5>
                <input
                  type="text"
                  class="form-control"
                  v-model="ocorrencia.nome_vitima"
                  :disabled="typePerson == 1"
                />
              </div>
              <div class="col-12" v-if="!nao_identificado">
                <h5>Data Nascimento</h5>
                <input
                  type="date"
                  class="form-control"
                  v-model="ocorrencia.data_nascimento_vitima"
                  :disabled="typePerson == 1"
                />
                <span
                  class="card-text bold"
                  style="margin-top: 5px"
                  v-if="ocorrencia.data_nascimento_vitima"
                  >{{ diffIdade }}</span
                >
                <h5>Telefone</h5>
                <input
                  type="text"
                  class="form-control"
                  v-model="ocorrencia.telefone"
                  :disabled="typePerson == 1"
                />
              </div>
              <div class="col-12" v-else>
                <h5>Idade aparente</h5>
                <input
                  type="text"
                  class="form-control"
                  v-model="ocorrencia.idade_vitima"
                />
              </div>
              <div class="col-12">
                <h5>Sexo</h5>
                <select
                  v-model="ocorrencia.sexo_vitima"
                  class="form-control"
                  :disabled="typePerson == 1"
                >
                  <option value="">Não informado</option>
                  <option value="F">Feminino</option>
                  <option value="M">Masculino</option>
                </select>
              </div>
              <div class="col-12 mt-2" v-if="typePerson == 1">
                <h5>Descreva exatamente o que você está sentindo</h5>
                <textarea
                  type="text"
                  class="form-control mb-3"
                  style="min-height: 10vh"
                  v-model="ocorrencia.queixa_principal"
                ></textarea>
              </div>
              <div class="col-12 mt-2" v-else>
                <h5>Descreva exatamente o que aconteceu</h5>
                <textarea
                  type="text"
                  class="form-control mb-3"
                  style="min-height: 10vh"
                  v-model="ocorrencia.queixa_principal"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="form-group botao-solicitar" v-if="personSelected">
            <div class="col-12">
              <button
                @click="verificaCidadeAtendimento()"
                type="button"
                class="btnn"
              >
                SOLICITAR
              </button>
            </div>
          </div>
        </div>
      </div>
      <a href="tel:192">
        <button
          class="btnn"
          style="
            background: #cc4444 !important;
            font-size: 7vw;
            margin: 4vh 0 0 0;
            height: 65vh;
            display: none;
          "
          id="discar"
        >
          O APP não atende este município, por favor disque 192
        </button>
      </a>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import vSelect from "vue-select";
import GmapMap from "vue2-google-maps";
import moment from "moment";
export default {
  data() {
    return {
      backgroundImages: [
        "login-samu-01.png",
        "login-samu-02.png",
        "login-samu-03.png",
        "login-samu-04.png",
        "login-samu-05.png",
      ],
      currentBackgroundIndex: 0,
      nao_identificado: false,
      mapLoaded: true,
      verificaCidade: false,
      position: {
        lat: 0,
        lng: 0,
      },
      personSelected: false,
      typePerson: "",
      usingGPS: true,
      ocorrencia: {
        latitude: 0,
        longitude: 0,
        logradouro: "",
        estado: 0,
        cidade: 0,
        logradouro: "",
        numero: "",
        queixa_principal: "",
        ip_solicitante: "",
        usuario_solicitante_id: 0,
        status: 0,
      },
      isDisabled: true,
      isLoading: false,
      loadingColor: "#5D9CEC",
      user: {
        usuario_id: "",
        usuario_nome: "",
      },
      cor: {
        eu: "rgb(21, 72, 138)",
        outro: "rgb(21, 72, 138)",
        gps: "rgb(21, 72, 138)",
        mapa: "rgb(21, 72, 138)",
        fav: "rgb(21, 72, 138)",
      },
      cidades: [],
      estados: [],
      favoritos: [],
      paciente: {},
      favorito_selecionado: {},
    };
  },
  computed: {
    backgroundStyle() {
      const imagePath = require(`@/assets/images/${
        this.backgroundImages[this.currentBackgroundIndex]
      }`);
      return {
        backgroundImage: `url(${imagePath})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      };
    },
    diffIdade() {
      const self = this;

      var a = moment();
      var b = moment(self.ocorrencia.data_nascimento_vitima);

      var years = a.diff(b, "year");
      b.add(years, "years");

      var months = a.diff(b, "months");
      b.add(months, "months");

      var days = a.diff(b, "days");

      if (years < 100) {
        return years + " anos, " + months + " meses, " + days + " dias";
      }
    },
  },
  created() {
    this.currentBackgroundIndex = Math.floor(
      Math.random() * this.backgroundImages.length
    );
  },
  methods: {
    changeBackgroundImage() {
      setInterval(() => {
        this.currentBackgroundIndex =
          (this.currentBackgroundIndex + 1) % this.backgroundImages.length;
      }, 5000);
    },
    selectFavorito() {
      const self = this;
      console.log(self.favorito_selecionado);

      self.ocorrencia.paciente_id = self.favorito_selecionado.paciente_id;
      self.ocorrencia.logradouro = self.favorito_selecionado.endereco;
      self.ocorrencia.bairro = self.favorito_selecionado.bairro;
      self.ocorrencia.cidade = self.favorito_selecionado.nome_municipio;
      self.ocorrencia.uf = self.favorito_selecionado.nome_estado;
      self.ocorrencia.numero = self.favorito_selecionado.numero;
      self.ocorrencia.cep = self.favorito_selecionado.cep;

      self.getLatLngOpenStreetMap();
    },
    buscar: function () {
      var self = this;

      if (self.ocorrencia.cep.slice(-1) == "_") {
        return;
      }

      self.naoLocalizado = false;

      self.usingGPS = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.ocorrencia.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.ocorrencia.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.ocorrencia.logradouro = self.endereco.logradouro;
            self.ocorrencia.bairro = self.endereco.bairro;
            self.ocorrencia.cidade = self.endereco.localidade;
            self.getUFId(self.endereco.uf);
            self.ocorrencia.uf = self.endereco.uf;
            $("#inputNumero").focus();

            self.getLatLngOpenStreetMap();
          }
        );
      }
    },
    getLatLngOpenStreetMap() {
      const self = this;

      self.mapLoaded = false;
      $.getJSON(
        "https://nominatim.openstreetmap.org/search?q=" +
          self.ocorrencia.numero +
          " " +
          self.ocorrencia.logradouro +
          " " +
          self.ocorrencia.cidade +
          "&format=json&polygon_geojson=1&addressdetails=1",
        function (latlon) {
          self.ocorrencia.latitude = Number(latlon[0].lat);
          self.ocorrencia.longitude = Number(latlon[0].lon);
          self.position.lat = Number(latlon[0].lat);
          self.position.lng = Number(latlon[0].lon);
          console.log("retornado do opsm", latlon);
          self.mapLoaded = true;
        }
      );
    },
    atendimento(id) {
      const self = this;

      self.personSelected = true;

      $("#form").show(100);
      if (id) {
        self.user.usuario_nome = self.$store.state.user.usuario_nome;
        self.ocorrencia.nome_vitima = self.$store.state.user.usuario_nome;
        self.ocorrencia.data_nascimento_vitima = self.paciente.data_nascimento;
        self.ocorrencia.sexo_vitima = self.paciente.sexo;
        self.ocorrencia.telefone = self.paciente.telefone;
        self.ocorrencia.paciente_id = self.$store.state.user.paciente_id;
        self.cor.eu = "rgb(21, 72, 138)";
        self.cor.outro = "#bbb";
        $("#geo-form").show();
        self.typePerson = 1;
      } else {
        self.user.usuario_nome = self.$store.state.user.usuario_nome;
        self.cor.eu = "#bbb";
        self.cor.outro = "rgb(21, 72, 138)";
        $("#geo-form").show();
        self.typePerson = 2;
      }
    },
    getEstados() {
      const self = this;
      self.isLoading = true;

      const api =
        self.$store.state.api + "ufs?paginated=false&orderByAsc=uf_nome";

      axios
        .get(api, this.usuario_id)
        .then((response) => {
          self.estados = response.data.data;
          self.isLoading = false;
          setTimeout(function () {
            self.getPacientes();
          }, 500);
        })
        .catch((error) => {
          self.isLoading = false;
        });
    },
    getCidades() {
      const self = this;
      self.isLoading = true;

      const api =
        self.$store.state.api +
        "municipios?paginated=false&orderByAsc=municipio_nome&uf_id=" +
        self.ocorrencia.estado;

      axios
        .get(api, this.usuario_id)
        .then((response) => {
          self.cidades = response.data.data;
          self.isLoading = false;
        })
        .catch((error) => {
          self.isLoading = false;
        });
    },
    getUFId(uf) {
      const self = this;
      const api = self.$store.state.api + "ufs?uf_nome=" + uf;

      axios
        .get(api, this.usuario_id)
        .then((response) => {
          self.ocorrencia.estado = response.data.data[0].uf_id;
        })
        .catch((error) => {
          self.isLoading = false;
        });
    },
    getPacientes() {
      const self = this;
      self.isLoading = true;

      const api =
        self.$store.state.api +
        "paciente?paciente_id=" +
        self.$store.state.user.paciente_id;
      axios
        .get(api, this.usuario_id)
        .then((response) => {
          self.paciente = response.data.data[0];
          self.isLoading = false;
        })
        .catch((error) => {
          self.isLoading = false;
        });
    },

    localizacao(id) {
      const self = this;

      switch (id) {
        case 0:
          self.cor.gps = "rgb(21, 72, 138)";
          self.cor.mapa = "#bbb";
          self.cor.fav = "#bbb";
          $("#geo-form").show();
          $("#favoritos").hide();
          $("#mapa").show();
          break;
        case 1:
          self.cor.gps = "#bbb";
          self.cor.mapa = "rgb(21, 72, 138)";
          self.cor.fav = "#bbb";
          $("#geo-form").show();
          $("#favoritos").hide();
          $("#mapa").show();
          break;
        case 2:
          self.cor.gps = "#bbb";
          self.cor.mapa = "#bbb";
          self.cor.fav = "rgb(21, 72, 138)";
          $("#geo-form").show();
          $("#favoritos").show();
          $("#mapa").show();
          break;
      }
    },

    criarOcorrencia() {
      const self = this;
      self.isLoading = true;
      let api = self.$store.state.api + "ocorrencia";

      if (
        self.ocorrencia.data_nascimento_vitima != "" &&
        !self.nao_identificado
      ) {
        self.ocorrencia.idade_vitima = self.diffIdade;
      }
      console.log("chegou na criaçãooo");

      axios
        .post(api, {
          ...self.ocorrencia,
          nao_identificado: self.nao_identificado,
        })
        .then((response) => {
          if (response.data.original.chamar) {
            self.$message(null, response.data.original.text, "error");
            $("#card-geral").hide();
            $("#discar").show();
          } else {
            self.$message(
              "Sucesso",
              `Atendimento criado com sucesso`,
              "success"
            );
            this.$router.push(
              "/visualizar-atendimento/" + response.data.original.ocorrencia_id
            );
          }
          self.isLoading = false;
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
    getIPAddress() {
      const self = this;
      return fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
          self.ocorrencia.ip_solicitante = data.ip; // Returns the IP address object
        });
    },
    myAddress() {
      const self = this;
      console.log(self.paciente);

      self.ocorrencia.logradouro = self.paciente.endereco;
      self.ocorrencia.bairro = self.paciente.bairro;
      self.ocorrencia.cidade = self.paciente.nome_municipio;
      self.getUFId(self.paciente.nome_estado);
      self.ocorrencia.uf = self.paciente.nome_estado;
      self.ocorrencia.numero = self.paciente.numero;
      self.ocorrencia.cep = self.paciente.cep;
      self.ocorrencia.telefone = self.paciente.telefone;

      self.getLatLngOpenStreetMap();
    },
    getGeo() {
      const self = this;
      self.isLoading = true;

      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          self.ocorrencia.latitude = position.coords.latitude;
          self.ocorrencia.longitude = position.coords.longitude;
          self.position.lat = position.coords.latitude;
          self.position.lng = position.coords.longitude;

          self.mapLoaded = true;

          setTimeout(function () {
            self.geocodeLatLng(
              position.coords.latitude,
              position.coords.longitude
            );
          }, 500);
        });

        $("#mapa").show();
      } else {
        console.log("Geolocalização não é suportada pelo seu navegador");
      }

      self.isLoading = false;
    },
    geocodeLatLng(lat, lng) {
      const self = this;
      self.isLoading = true;
      const geocoder = new google.maps.Geocoder();

      let latlng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };

      geocoder
        .geocode({ location: latlng })
        .then((response) => {
          console.log(response);
          if (response.results[0]) {
            self.ocorrencia.numero =
              response.results[0].address_components[0].long_name;
            self.ocorrencia.logradouro =
              response.results[0].address_components[1].long_name;
            self.ocorrencia.bairro =
              response.results[0].address_components[2].long_name;
            self.ocorrencia.cidade =
              response.results[0].address_components[3].long_name;
            self.ocorrencia.estado =
              response.results[0].address_components[4].short_name;
            self.ocorrencia.cep =
              response.results[0].address_components[6].short_name;
          } else {
          }
          self.isLoading = false;
        })
        .catch((error) => {
          self.isLoading = false;
        });
    },
    discar192() {
      window.location.href = "tel:" + 192;
    },
    verificaCidadeAtendimento() {
      const self = this;

      var cidade = self.ocorrencia.cidade;

      self.isLoading = true;
      let api = self.$store.state.api + "verifica-cidade";

      axios
        .post(api, { cidade: cidade })
        .then((response) => {
          console.log(response);
          if (response.data == false) {
            swal({
              title: "Você está fora da nossa área de cobertura!",
              text: "Deseja discar para o 192 da sua região?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Sim, deletar!",
              showLoaderOnConfirm: true,
              buttons: {
                catch: {
                  text: "Não",
                  value: "cancel",
                  className: "btn btn-danger",
                },
                confirm: {
                  text: "Sim",
                  value: "confirm",
                  className: "btn btn-success",
                },
              },
            }).then((value) => {
              switch (value) {
                case "cancel":
                  swal(
                    "Atenção",
                    "Para chamar o SAMU através deste App, você deverá informar um endereço que esteja dentro da nossa área de atendimento.",
                    "info"
                  );
                  break;

                case "confirm":
                  window.location.href = "tel:" + 192;
                  break;
              }
            });
          } else {
            self.criarOcorrencia();
          }
          self.isLoading = false;
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
  },
  components: {
    Loading,
    vSelect,
  },
  props: {},
  mounted: function () {
    const self = this;
    self.isLoading = true;

    self.getEstados();

    $("#menu-main").removeClass("show");
    $(".offcanvas-backdrop.show").removeClass("show");
    /* $(".theme-light").removeAttribute("style","overflow: hidden; padding-right: 0px;"); */
    // document.body.setAttribute("style", null);

    self
      .getIPAddress()
      .then((ipAddress) => {
        this.ocorrencia.ip = ipAddress; // Print the user's IP address
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    // self.getGeo();
  },
};
</script>
<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.custom-input {
  border-radius: 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control:focus {
  z-index: 3;
}

.custom-input-container {
  position: relative;
}

.custom-input {
  padding: 0.375rem 0.75rem;
  height: 2.714rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  /* box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.15); */
  width: 100%;
}

.custom-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.vue-map-container .vue-map .gm-style {
  border-radius: 30px !important;
}

.botao-solicitar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.btnn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
  margin: 0px 15px 18px -29px;
}

.btnnn {
  width: 100% !important;
  background-color: rgb(21, 72, 138) !important;
}

.btnnn-navigation {
  width: 100% !important;
  background-color: rgb(50, 124, 221) !important;
}

.btn-gps {
  background-color: rgb(21, 72, 138) !important;
  border: 0;
  border-radius: 8px;
  padding: 5px;
  width: 100%;
  color: white;
  font-size: 11px;
}

.btn-gps2 {
  background-color: rgb(21, 72, 138) !important;
  border: 0;
  border-radius: 8px;
  padding: 5px;
  width: 65%;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/SolicitarAtendimento.vue